import React, { useState } from 'react';
import { Modal } from 'react-responsive-modal';
import styled from 'styled-components';

import 'react-responsive-modal/styles.css';
import '../../styles/CustomModal.css';
import CustomTable from '../Table';
import Pagination from '../../components/Pagination';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

// details
const details = [
  {
    id: 0,
    phoneNumber: '010-1234-1234',
    count: 10,
    recentDate: '2024.01.10',
    success: true,
  },
  {
    id: 1,
    phoneNumber: '010-1234-1234',
    count: 10,
    recentDate: '2024.01.11',
    success: false,
  },
  {
    id: 2,
    phoneNumber: '010-1234-1234',
    count: 10,
    recentDate: '2024.01.12',
    success: true,
  },
  {
    id: 3,
    phoneNumber: '010-1234-1234',
    count: 10,
    recentDate: '2024.01.13',
    success: true,
  },
  {
    id: 4,
    phoneNumber: '010-1234-1234',
    count: 10,
    recentDate: '2024.01.14',
    success: true,
  },
];

//테이블 헤더
const tableHeader = ['', '전화번호', '이용횟수', '최근 방문일', '수신성공여부'];
const mobileTableHeader = ['', '전화번호', '이용횟수', '최근방문일', '수신여부'];
const renderTableItem = () => {
  return (
    <>
      {details.map((data: any, index: number) => (
        <tr key={index} className="webTableWrap">
          <td>{index + 1}</td>
          <td>{data.phoneNumber}</td>
          <td>{data.count}회</td>
          <td>{data.recentDate}</td>
          <td className={`${!data.success && 'failed'}`}>{data.success ? '성공' : '실패'}</td>
        </tr>
      ))}
    </>
  );
};

const OrganizationTalkModal = ({ isVisible, setVisible }: Props) => {
  // 현재 페이지
  const [currentPage, setCurrentPage] = useState<number>(1);
  // 당일 매출건수의 페이지 개수
  const [pageCount, setPageCount] = useState<number>(4);

  const onClose = () => {
    setVisible(false);
  };

  return (
    <Modal
      open={isVisible}
      onClose={onClose}
      center
      blockScroll={false}
      classNames={{
        overlay: 'organizationTalkModalOverlay',
        modal: 'organizationTalkModal',
        root: 'customModalRoot',
      }}
      showCloseIcon={true}
      animationDuration={150}>
      <Style>
        <div className="modalWrapper">
          <h2>단체알림톡 상세보기</h2>
          <h4>2024-01-08 11:00:00</h4>
          <div className="titleWrap">
            <h3>총 발송 건수 100건</h3>
            <div className="row">
              <h3 className="success">성공 건수 99건</h3>
              <h3 className="failed">실패 건수 1건</h3>
            </div>
          </div>
          <CustomTable
            tableHeader={window.innerWidth < 900 ? mobileTableHeader : tableHeader}
            renderTableItem={renderTableItem}
            type="noneborder"
          />
          <div className="paginationWrap">
            <Pagination
              pageCount={pageCount}
              forcePage={currentPage - 1}
              handlePageClick={() => {}}
            />
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default OrganizationTalkModal;

const Style = styled.div`
  h1,
  h2,
  h3,
  h4,
  p {
    padding: 0;
    margin: 0;
  }
  /* modalWrapper */
  .modalWrapper {
    height: 100%;
    padding: 5% 10%;
    background: #fff;
    overflow: hidden;
  }

  h2 {
    text-align: left;
    font-weight: 600;
    padding-bottom: 30px;
  }
  h4 {
    text-align: right;
    color: #a7a7a7;
    font-weight: 400;
    padding: 6px 0;
  }

  .titleWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e3e3e3;
    border-radius: 5px;
    padding: 12px 46px;
    margin-bottom: 16px;

    .row {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    h3 {
      font-weight: 500;
    }
    h3.success {
      color: #237ce4;
    }
    h3.failed {
      color: #ff5757;
    }
  }

  td.failed {
    color: #ff5757;
  }

  ul {
    margin-top: 30px;
  }
  li {
    margin: 0 6px;
    a {
      border: none;
      padding: 10px 12px;
      font-size: 16px;
      color: #a7a7a7;
      font-weight: 400;
      width: 100%;
    }
  }
  .active {
    margin: 0 6px;
    a {
      background: none;
      color: #000000;
      font-weight: 600;
    }
  }

  @media (max-width: 900px) {
    .modalWrapper {
      padding: 32px 4% 12px 4%;
    }
    .titleWrap {
      padding: 30px;
      align-items: flex-start;
      flex-direction: column;
      gap: 10px;
    }
    tr {
      td:nth-child(1) {
        font-size: 12px;
      }
    }
    ul {
      margin-top: 16px;
    }
  }
`;
